import L from 'leaflet';

const highlightTargetedMeetup = () => {
    const hash = window.location.hash;

    if (
        ! hash
        || ! hash.startsWith(
            '#festival-meetup-'
        )
    ) {
        return;
    }

    const target = document.querySelector(
        hash
    );

    if (!(target instanceof HTMLElement)) {
        return;
    }

    target.classList.add(
        'ring-4',
        'ring-amber-400',
        'ring-offset-4',
        'ring-offset-slate-950',
        'transition-all',
        'duration-500'
    );

    window.setTimeout(
        () => {
            target.classList.remove(
                'ring-4',
                'ring-amber-400',
                'ring-offset-4',
                'ring-offset-slate-950'
            );
        },
        2500
    );
};
const initializeFestivalMeetupForms = () => {
    const forms = document.querySelectorAll(
        '[data-festival-meetup-form]'
    );

    forms.forEach((form) => {
        const locationType = form.querySelector(
            '[name="location_type"]'
        );

        const panels = form.querySelectorAll(
            '[data-location-panel]'
        );

        if (! locationType || panels.length === 0) {
            return;
        }

        const pinPicker = form.querySelector(
            '[data-meetup-pin-picker]'
        );

        const pinMapElement = form.querySelector(
            '[data-meetup-pin-map]'
        );

        const latitudeInput = form.querySelector(
            '[data-meetup-latitude]'
        );

        const longitudeInput = form.querySelector(
            '[data-meetup-longitude]'
        );

        const latitudeDisplay = form.querySelector(
            '[data-meetup-latitude-display]'
        );

        const longitudeDisplay = form.querySelector(
            '[data-meetup-longitude-display]'
        );

        let pinMap = null;
        let pinMarker = null;

        const updateCoordinateDisplays = (
            latitude,
            longitude
        ) => {
            if (latitudeDisplay) {
                latitudeDisplay.textContent =
                    Number.isFinite(latitude)
                        ? latitude.toFixed(7)
                        : 'Not selected';
            }

            if (longitudeDisplay) {
                longitudeDisplay.textContent =
                    Number.isFinite(longitude)
                        ? longitude.toFixed(7)
                        : 'Not selected';
            }
        };

        const savePinCoordinates = (
            latitude,
            longitude
        ) => {
            if (latitudeInput) {
                latitudeInput.value =
                    latitude.toFixed(7);
            }

            if (longitudeInput) {
                longitudeInput.value =
                    longitude.toFixed(7);
            }

            updateCoordinateDisplays(
                latitude,
                longitude
            );
        };

        const meetupPinIcon = L.divIcon({
            className: '',
            html: `
        <div
            style="
                display:flex;
                align-items:center;
                justify-content:center;
                width:42px;
                height:42px;
                border-radius:9999px;
                border:3px solid white;
                background:#f59e0b;
                color:white;
                font-size:20px;
                box-shadow:0 8px 24px rgba(0,0,0,.5);
            "
            aria-hidden="true"
        >
            ⭐
        </div>
    `,
            iconSize: [42, 42],
            iconAnchor: [21, 21],
            popupAnchor: [0, -24],
        });
        const placePin = (
            latitude,
            longitude,
            centerMap = false
        ) => {
            if (! pinMap) {
                return;
            }

            const coordinates = L.latLng(
                latitude,
                longitude
            );

            if (! pinMarker) {
                pinMarker = L.marker(
                    coordinates,
                    {
                        draggable: true,
                        icon: meetupPinIcon,
                    }
                ).addTo(pinMap);

                pinMarker.on(
                    'dragend',
                    () => {
                        const position =
                            pinMarker.getLatLng();

                        savePinCoordinates(
                            position.lat,
                            position.lng
                        );
                    }
                );
            } else {
                pinMarker.setLatLng(
                    coordinates
                );
            }

            if (centerMap) {
                pinMap.setView(
                    coordinates,
                    Math.max(
                        pinMap.getZoom(),
                        17
                    ),
                    {
                        animate: true,
                    }
                );
            }

            savePinCoordinates(
                latitude,
                longitude
            );
        };

        const initializePinMap = () => {
            if (
                pinMap
                || ! pinPicker
                || ! pinMapElement
            ) {
                return;
            }

            const festivalLatitude =
                Number.parseFloat(
                    pinPicker.dataset
                        .festivalLatitude
                );

            const festivalLongitude =
                Number.parseFloat(
                    pinPicker.dataset
                        .festivalLongitude
                );

            if (
                ! Number.isFinite(
                    festivalLatitude
                )
                || ! Number.isFinite(
                    festivalLongitude
                )
            ) {
                return;
            }

            pinMap = L.map(
                pinMapElement,
                {
                    zoomControl: true,
                    scrollWheelZoom: false,
                }
            ).setView(
                [
                    festivalLatitude,
                    festivalLongitude,
                ],
                17
            );

            L.tileLayer(
                'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                {
                    maxZoom: 20,
                    attribution:
                        '&copy; OpenStreetMap contributors',
                }
            ).addTo(pinMap);

            const festivalIcon = L.divIcon({
                className: '',
                html: `
                    <div
                        style="
                            display:flex;
                            align-items:center;
                            justify-content:center;
                            width:38px;
                            height:38px;
                            border-radius:9999px;
                            border:3px solid white;
                            background:#0891b2;
                            font-size:18px;
                            box-shadow:0 8px 20px rgba(0,0,0,.4);
                        "
                        aria-hidden="true"
                    >
                        🎪
                    </div>
                `,
                iconSize: [38, 38],
                iconAnchor: [19, 19],
                popupAnchor: [0, -22],
            });

            L.marker(
                [
                    festivalLatitude,
                    festivalLongitude,
                ],
                {
                    icon: festivalIcon,
                    interactive: false,
                }
            ).addTo(pinMap);

            pinMap.on(
                'click',
                (event) => {
                    placePin(
                        event.latlng.lat,
                        event.latlng.lng
                    );
                }
            );

            const savedLatitude =
                Number.parseFloat(
                    latitudeInput?.value
                );

            const savedLongitude =
                Number.parseFloat(
                    longitudeInput?.value
                );

            if (
                Number.isFinite(savedLatitude)
                && Number.isFinite(savedLongitude)
            ) {
                placePin(
                    savedLatitude,
                    savedLongitude,
                    true
                );
            } else {
                updateCoordinateDisplays(
                    Number.NaN,
                    Number.NaN
                );
            }

            window.setTimeout(
                () => {
                    pinMap.invalidateSize();
                },
                100
            );
        };

        const updateLocationPanels = () => {
            const selectedType =
                locationType.value;

            panels.forEach((panel) => {
                const isActive =
                    panel.dataset.locationPanel
                    === selectedType;

                panel.classList.toggle(
                    'hidden',
                    ! isActive
                );

                panel
                    .querySelectorAll(
                        'input, select, textarea'
                    )
                    .forEach((field) => {
                        field.disabled = ! isActive;
                    });
            });

            const festivalArea =
                form.querySelector(
                    '[name="festival_area"]'
                );

            const locationName =
                form.querySelector(
                    '[name="location_name"]'
                );

            if (festivalArea) {
                festivalArea.required =
                    selectedType
                    === 'festival_area';
            }

            if (locationName) {
                locationName.required =
                    selectedType === 'custom';
            }

            if (selectedType === 'gps') {
                initializePinMap();

                window.setTimeout(
                    () => {
                        pinMap?.invalidateSize();
                    },
                    100
                );
            }
        };

        locationType.addEventListener(
            'change',
            updateLocationPanels
        );

        // A pin map created while its drawer was closed has no size until the drawer opens.
        form.closest('details')?.addEventListener('toggle', () => {
            window.setTimeout(() => pinMap?.invalidateSize(), 50);
        });

        updateLocationPanels();
    });
};

const initializeFestivalMeetupEditModals = () => {
    const openButtons = document.querySelectorAll(
        '[data-meetup-edit-open]'
    );

    const closeModal = (modal) => {
        if (!(modal instanceof HTMLDialogElement)) {
            return;
        }

        if (modal.open) {
            modal.close();
        }
    };

    openButtons.forEach((button) => {
        if (button.dataset.meetupEditInitialized === 'true') {
            return;
        }

        button.dataset.meetupEditInitialized = 'true';

        button.addEventListener('click', () => {
            const targetId =
                button.dataset.meetupEditTarget;

            if (! targetId) {
                return;
            }

            const modal = document.getElementById(
                targetId
            );

            if (!(modal instanceof HTMLDialogElement)) {
                return;
            }

            modal.showModal();

            window.setTimeout(() => {
                modal
                    .querySelectorAll(
                        '[data-meetup-pin-map]'
                    )
                    .forEach((mapElement) => {
                        mapElement.dispatchEvent(
                            new CustomEvent(
                                'festival:meetup-map-visible',
                                {
                                    bubbles: true,
                                }
                            )
                        );
                    });
            }, 100);
        });
    });

    document
        .querySelectorAll('[data-meetup-edit-modal]')
        .forEach((modal) => {
            if (
                !(
                    modal instanceof HTMLDialogElement
                )
                || modal.dataset
                    .meetupEditInitialized === 'true'
            ) {
                return;
            }

            modal.dataset.meetupEditInitialized = 'true';

            modal
                .querySelectorAll(
                    '[data-meetup-edit-close]'
                )
                .forEach((button) => {
                    button.addEventListener(
                        'click',
                        () => {
                            closeModal(modal);
                        }
                    );
                });

            modal.addEventListener(
                'cancel',
                (event) => {
                    event.preventDefault();
                    closeModal(modal);
                }
            );

            modal.addEventListener(
                'click',
                (event) => {
                    if (event.target === modal) {
                        closeModal(modal);
                    }
                }
            );
        });

    document
        .querySelectorAll(
            '[data-meetup-edit-auto-open]'
        )
        .forEach((modal) => {
            if (
                !(
                    modal
                    instanceof HTMLDialogElement
                )
                || modal.open
            ) {
                return;
            }

            modal.showModal();

            window.setTimeout(
                () => {
                    const firstInvalidField =
                        modal.querySelector(
                            ':invalid'
                        );

                    if (
                        firstInvalidField
                        instanceof HTMLElement
                    ) {
                        firstInvalidField.focus();
                    }
                },
                100
            );
        });
};

// The create form sits in a closed <details>; links to it (or into it) open it first.
const openTargetedMeetupDrawer = () => {
    const hash = window.location.hash;

    if (! hash || hash.length < 2) {
        return;
    }

    let target = null;

    try {
        target = document.querySelector(hash);
    } catch {
        return;
    }

    const drawer = target?.closest('[data-festival-meetup-create]');

    if (drawer instanceof HTMLDetailsElement && ! drawer.open) {
        drawer.open = true;
        drawer.scrollIntoView({ block: 'start' });
    }
};

const initializeFestivalMeetups = () => {
    openTargetedMeetupDrawer();
    window.addEventListener('hashchange', openTargetedMeetupDrawer);
    initializeFestivalMeetupForms();
    initializeFestivalMeetupEditModals();
    highlightTargetedMeetup();
};

if (document.readyState === 'loading') {
    document.addEventListener(
        'DOMContentLoaded',
        initializeFestivalMeetups,
        {
            once: true,
        }
    );
} else {
    initializeFestivalMeetups();
}